<template>
  <div  v-if="isLargeScreen">

    <div>
      <Breadcrumbs main="Help" title="Help" />

      <div class="container-fluid">
          <div class="row widget-grid m-lg-5">
              <HelpCard />
          </div>
      </div>
    </div>
  </div>
  <div v-else>
    <MobileHelp />
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import HelpCard from './helpCard.vue';
import MobileHelp from './mobile/index.vue';

const isLargeScreen = ref(true);
  
  // 檢查螢幕大小
  function checkScreenSize() {
    isLargeScreen.value = window.innerWidth >= 992;
  }
  
  onMounted(() => {
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
  });
  
  onUnmounted(() => {
    window.removeEventListener('resize', checkScreenSize);
  });
</script>